import moment from "moment";
import store from "@/store";
class Helper {
  formatReal(n) {
    // parseFloat(n)
    return n
      .toFixed(2)
      .replace(".", ",")
      .replace(/(\d)(?=(\d{3})+\,)/g, "$1.");
  }

  formatQuantidade(n) {
    // parseFloat(n)
    return n
      .toFixed(3)
      .replace(".", ",")
      .replace(/(\d)(?=(\d{3})+\,)/g, "$1.");
  }

  formatReal2(n) {
    // parseFloat(n)
    return n
      .toFixed(2)
      .replace(".", ",")
      .replace(/(\d)(?=(\d{3})+\,)/g, "$1.");
  }

  firstName(name) {
    let firstName = name.split(" ");
    return firstName[0];
  }

  cleanFormatReal(value) {
    if (value) {
      var data = value
        .replace(".", "")
        .replace(",", ".")
        .toString();
      return parseFloat(data);
    }
  }

  firstName(name) {
    let firstName = name.split(" ");
    return firstName[0];
  }

  // cleanFormatReal(value){
  //   var data = value.replace(".", "").replace(",",".")
  //   return data
  // }

  // showErrors(data){
  //   let stringErrors = [];
  //   Object.keys(data).map(value => {
  //        return stringErrors.push(`${data[value]}`);
  //   });

  //   store.commit('alertError', stringErrors)
  // }

  verificaPermissao(permissao) {
    let permissoes = store.getters.getUser.perfil.permissoes.filter((item) => {
      return item.permissao == permissao;
    });

    if (permissoes.length > 0) {
      return true;
    }

    if (
      store.getters.getUser.perfil.perfil == "SUPORTE" ||
      store.getters.getUser.perfil.perfil == "Suporte"
    ) {
      return true;
    }
  }

  solicitarPermissao(perfil, permissao) {
    let permissoes = perfil.permissoes.filter((item) => {
      return item.permissao == permissao;
    });

    if (permissoes.length > 0) {
      return true;
    }

    if (perfil.perfil == "Suporte") {
      return true;
    }
  }

  // permissaoView(permissao){
  //   if(!this.verificaPermissao(permissao)){
  //     store.commit('snackbarError', 'Sem permissão.')
  //     router.push({name: 'inicio'})
  //   }
  // }

  formatDateTime(n) {
    return moment(n, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm");
  }
  formatDate(n) {
    return moment(n, "YYYY-MM-DD").format("DD/MM/YYYY");
  }
  getEstoquePrincipalProduto(produto) {
    const estoque = produto.estoques.filter(
      (data) => data.estoque.principal === true
    );
    if (estoque[0]) return estoque[0].quantidade;
  }
}

export default new Helper();
